import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { clickedCardEvent } from '../../../Utils/CategoryPageUtils';
import { removeDefaultParams } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { harcodedTextFlagData } from '../../CategoryDetail/CategoryProductTags/constant';
import { ProductFlag } from '../../CategoryDetail/L1CategoryPage/ProductCardNew/styled';
import { LightningPrice } from '../../MaternityWear/MaternityProductCards/styled';
import { sizeString } from '../../MaternityWear/constants';
import { Rating } from '../../StoreHomePage/ProductCard/styled';
import AddToCartCta from './AddToCartCta';
import {
  AddButtonContainer,
  CardMainSection,
  CardTitle,
  TextSection,
} from './CategoryNewStyled';
import PriceSection from './PriceSection';
import {
  ProductNewImageDiv,
  ProductNewImageSection,
  VariantName,
} from './styled';
import { queryParamHandling } from '../../../Utils/productPageUtils';

export default function StickyCategoryCard(props) {
  const {
    data,
    setAddedToCart,
    section,
    category_name,
    searchallProduct,
    notFireEvent,
    parentTag,
    rupeeSymbol,
    index,
    userType,
    outerIndex,
  } = props;
  const router = useRouter();
  const ratingString = data?.starRatingSubScript;
  const ratingText =
    (ratingString?.slice(0, ratingString.length - 1) || data?.ratingCount) +
    ' Ratings)';
  const ratingCountString = `(${data?.ratingCount} Ratings)`;
  const productName = data?.name || data?.title;
  const [cardEffect, setCardEffect] = useState('');
  const lightining = data?.actual_web_price;
  const cardClickHandler = () => {
    let url = data?.webUrl + window?.location?.search;
    if (!notFireEvent) {
      clickedCardEvent(section, data, category_name, url);
    }
  };
  const productFlagData = data?.textFlag || harcodedTextFlagData;
  const productImage = data?.image || data?.images?.[0];
  const productImageAltText = data?.altText || data?.nickname;

  return (
    <CardMainSection className={`hoverable_section ${cardEffect}`}>
      <div className="animated_card">
        <div onClick={cardClickHandler}>
          <Link
            href={{
              pathname: data?.webUrl || data?.web_url,
              query: removeDefaultParams(router.query),
            }}
            passHref
            locale={false}
            onClick={(e) => {
              e.preventDefault();
              setCardEffect('lowOpacity');
              const { addParams, newUrl } = queryParamHandling(
                data?.webUrl || data?.web_url,
              );

              setTimeout(() => {
                router.push(newUrl + addParams, '', {
                  locale: getRouterLocale(router),
                });
              }, [200]);
            }}
          >
            <ProductNewImageSection>
              {/* <ProductNewImage
                                src={data?.image}
                                srcSet={`${data?.image}?tr=w-400 1x,${data?.image}?tr=w-400 2x,${data?.image}?tr=w-600 3x,${data?.image}?tr=w-800 4x`}
                                loading="lazy"
                                alt={productName}
                            /> */}
              <ProductNewImageDiv>
                {productFlagData?.text?.length > 0 && (
                  <ProductFlag flagData={productFlagData}>
                    {productFlagData?.text}
                    <span></span>
                  </ProductFlag>
                )}
                {productImage && (
                  <Image
                    src={productImage}
                    alt={productImageAltText}
                    title={data?.nickname}
                    loading={index < 2 && outerIndex == 0 ? 'eager' : 'lazy'}
                    quality={90}
                    priority={outerIndex == 0 && index < 2}
                    fill
                    sizes="33vw"
                  />
                )}
              </ProductNewImageDiv>
            </ProductNewImageSection>
            <TextSection lightning={lightining}>
              <div className="textContainer">
                <CardTitle as={'div'}>{productName}</CardTitle>
                <VariantName searchallProduct={searchallProduct} perUnit>
                  {data?.variantType?.length
                    ? `${data?.variantSnippet}: ${sizeString(
                        data?.variantType,
                      )}`
                    : ''}
                </VariantName>
                <PriceSection
                  rupeeSymbol={rupeeSymbol}
                  data={data}
                  userType={userType}
                  isCategory={true}
                />
                {lightining && (
                  <LightningPrice categoryPage={true}>
                    <img src={images.lightning} alt="" />
                    <p>Deal Price {data?.price}</p>
                  </LightningPrice>
                )}
                {data?.starRating > 0 && (
                  <Rating category>
                    <span>{data?.starRating}</span>
                    <img
                      src={images.filledStar}
                      alt="filledStar"
                      title="filledStar"
                    />
                    <span className="total_ratingnumber">
                      {ratingString ? ratingText : ratingCountString}
                    </span>
                  </Rating>
                )}
              </div>
              <AddButtonContainer>
                <AddToCartCta
                  product={data}
                  section={section}
                  category_name={category_name}
                  setAddedToCart={setAddedToCart}
                  parentTag={parentTag}
                  smallButton={true}
                  isCategoryPage={true}
                />
              </AddButtonContainer>
            </TextSection>
          </Link>
        </div>
      </div>
    </CardMainSection>
  );
}
